import { type ReactNode } from 'react'
import cx from 'classnames'
import {
  Breadcrumbs as AriaBreadcrumbs,
  Breadcrumb as AriaBreadcrumb,
} from 'react-aria-components'
import { type To } from 'react-router'
import { RawLink } from '@/components/Link'
import { Icon } from '@/components/Icon'
import styles from './Breadcrumbs.module.css'
import { AutoSkeleton, useIsSkeleton } from '@/components/Skeleton'

export interface BreadcrumbsProps {
  children?: ReactNode
  testId?: string
}

export function Breadcrumbs({ children, testId }: BreadcrumbsProps) {
  return (
    <AriaBreadcrumbs data-test={testId} className={styles.breadcrumbs}>
      {children}
    </AriaBreadcrumbs>
  )
}

export interface BreadcrumbItemProps {
  children?: ReactNode
  to?: To
  href?: string
  onPress?: () => unknown
  isSkeleton?: boolean
  testId?: string
}

export function BreadcrumbItem({
  children,
  to,
  href,
  onPress,
  isSkeleton,
  testId,
}: BreadcrumbItemProps) {
  isSkeleton = useIsSkeleton(isSkeleton)

  if (to || href || onPress) {
    return (
      <AriaBreadcrumb data-test={testId} className={styles.breadcrumb}>
        <RawLink
          to={to}
          href={href}
          onPress={onPress}
          className={({ isFocusVisible }) =>
            cx(styles.link, isFocusVisible && styles.focusVisible)
          }
        >
          <AutoSkeleton isSkeleton={isSkeleton}>{children}</AutoSkeleton>
        </RawLink>
        <Icon skeleton={isSkeleton} sm name="chevron" variant="secondary" />
      </AriaBreadcrumb>
    )
  }

  return (
    <AriaBreadcrumb data-test={testId} className={styles.current}>
      <AutoSkeleton isSkeleton={isSkeleton}>{children}</AutoSkeleton>
    </AriaBreadcrumb>
  )
}
